import store from "@/store/index";
const hallIfmID = "iframeHall";
const gameIfmID = "iframeGame";

const ifmTool = {
    configMiniGame: function (dataStr) {
        //配置小游戏
        let app = store.state.app;
        const data = {
            action: "configMiniGame",
            data: dataStr,
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    updateAccountBalance() {
        //更新账户余额
        let app = store.state.app;
        const data = {
            action: "updateAccountBalance",
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    nextGame: function () {
        //小游戏下一局
        let app = store.state.app;
        const data = {
            action: "nextGame",
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    confirmGame: function () {
        //小游戏，确认
        let app = store.state.app;
        const data = {
            action: "confirmGame",
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    closeGame: function () {
        //关闭热门游戏推荐
        let app = store.state.app;
        const data = {
            action: "closeGame",
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    activeGameHall: function () {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "activeGameHall",
        },
            "*"
        );
    },
    stopGameHall: function () {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "stopGameHall",
        },
            "*"
        );
    },
    postDownLoadData: function (gameID, percent) {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "updateDownLoadData",
            gameID: gameID,
            percent: percent,
        },
            "*"
        );
    },
    postDownLoadDataReady: function (gameID) {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "postDownLoadDataReady",
            gameID: gameID,
        },
            "*"
        );
    },
    postDownLoadError: function (gameID) {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "postDownLoadError",
            gameID: gameID,
        },
            "*"
        );
    },
    postAndroidGameInfo: function (data) {
        document.getElementById(hallIfmID).contentWindow.postMessage({
            action: "getAndroidGameInfo",
            gameInfo: data,
        },
            "*"
        );
    },
    /**是否全屏 */
    postFullSceenInfo: function (fullSceen) {
        const data = {
            action: "requestFullSceen",
            fullSceen: fullSceen,
        };
        document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
    },
    reload() {
        //重新加载页面 
        let app = store.state.app;
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.location.reload();
        } else {
            document.getElementById(gameIfmID).contentWindow.location.reload();
        }
    },
    updateUserGold(gold) {
        //更新用户余额
        let app = store.state.app;
        const data = {
            action: "updateUserGold",
            gold: gold
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    },
    actIfmClosed() {
        /**活动Ifm关闭回调 */
        let app = store.state.app;
        const data = {
            action: "actIfmClosed"
        };
        if (app.gameIfmUrl == "") {
            document.getElementById(hallIfmID).contentWindow.postMessage(data, "*");
        } else {
            document.getElementById(gameIfmID).contentWindow.postMessage(data, "*");
        }
    }
};
export default ifmTool;